const authDefaultState = {
    currentView: 'login',
    name: '',
    email: '',
    phone: '',
    password: '',
    password_confirm: '',
    error: '',
    success: false,
    loading: false,
    logged_in: null,
    token: null,
    acceptTerms: true,
    user: {},
    currentOrder: {
        id: ''
    }
};

export default (state = authDefaultState, action) => {

    switch(action.type) {
        case "VIEW_LOGIN":
            return {
                ...authDefaultState,
                currentView: 'login'
            };

        case "VIEW_REGISTER":
            return {
                ...authDefaultState,
                currentView: 'register'
            };

        case "VIEW_FORGOT_PASSWORD":
            return {
                ...authDefaultState,
                currentView: 'forgotpassword'
            };

        case 'AUTH_FORM_UPDATE':
            return {
                ...state,
                [action.field.prop]: action.field.value
            }

        case 'AUTH_UPDATE_USER_ADDRESSES':
            return {
                ...state,
                user: {
                    ...state.user,
                    addresses: action.addresses
                }
            };

        case "AUTH_SUCCESS":

            // add the token to async storage
            window.localStorage.setItem("c2o.token", action.token);

            return {
                ...state,
                first_name: '',
                last_name: '',
                email: '',
                password: '',
                loading: false,
                error: '',
                success: false,
                logged_in: true,
                token: action.token,
                user: action.userInfo
            };

        case "UPDATE_ORDER_TAGGED":
            return{
                ...state,
                [state.user.orderHistory]: action.orderHistory.map((item) => {
                        if(item.id == action.order_id){
                            item.tagged = action.tagged;
                        }
                        return item;
                    })
            }

        case "AUTH_ERROR":
            return {
                ...state,
                error: action.error,
                loading: false,
                success: false
            };

        case "NOT_LOGGED_IN":
            return {
                ...state,
                logged_in: false
            };

        case "AUTH_LOADING":
            return {
                ...state,
                loading: true
            }

        case "AUTH_LOADING_OFF":
            return {
                ...state,
                loading: false
            }

        case "AUTH_USER_UPDATE":
            return {
                ...state,
                user: {
                    ...state.user,
                    [action.field.prop]: action.field.value
                }
            }

        case "LOAD_PROFILE_FORM":
            return {
                ...state,
                first_name: state.user.first_name,
                last_name: state.user.last_name,
                password: '',
                password_confirm: '',
                loading: false,
                success: false,
                error: ''
            };

        case "RESET_PASSWORD_SUCCESS":
            return {
                ...state,
                success: "Thanks, an e-mail has been sent to you to reset your password.",
                error: false,
                loading: false
            };

        case "AUTH_LOGOUT":
            return {
                ...authDefaultState,
                logged_in: false
            };

        case "UPDATE_CURRENT_ORDERS":

            let currentOrder = action.currentOrders.find((order) => {
                return order.order_id == state.currentOrder.order_id;
            });
            
            if(currentOrder == null){
                currentOrder = {id: ''};
            }

            return {
                ...state,
                user: {
                    ...state.user,
                    currentOrders: action.currentOrders
                },
                currentOrder: currentOrder
            };

        case "SET_CURRENT_ORDER":

            if(action.addToCurrentOrders){

                let currentOrdersTemp = [];
                currentOrdersTemp.push(action.currentOrder);

                return {
                    ...state,
                    user: {
                        currentOrders: currentOrdersTemp
                    },
                    currentOrder: action.currentOrder
                };

            }else{
                return {
                    ...state,
                    currentOrder: action.currentOrder
                };    
            }
    
        default:
            return state;

    }
};